export default __webpack_public_path__ + "static/media/angi.8b51f409.webp";